/**
 * LoadingState.js
 *
 * Skeleton/spinner component displayed while loading data
 */

import React from 'react';
import './Shared.css';

/**
 * LoadingState Component
 *
 * Props:
 * - message: Loading message (optional)
 * - variant: Loading variant ('skeleton', 'spinner', 'pulse')
 * - className: Additional CSS classes
 */
const LoadingState = ({
  message = 'Loading...',
  variant = 'spinner',
  className = ''
}) => {
  return (
    <div className={`loading-state loading-${variant} ${className}`}>
      {variant === 'spinner' && <div className="spinner"></div>}
      {variant === 'skeleton' && (
        <div className="skeleton-container">
          <div className="skeleton-line"></div>
          <div className="skeleton-line"></div>
          <div className="skeleton-line short"></div>
        </div>
      )}
      {variant === 'pulse' && <div className="pulse"></div>}
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingState;
